var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "url(#paint0_linear_11855_14717)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "url(#paint1_linear_11855_14717)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0177 4C7.50064 4 4 7.30129 4 11.7603C4 14.0926 4.95839 16.1081 6.51839 17.5003C6.78774 17.7426 6.73226 17.8829 6.77806 19.3787C6.78167 19.4835 6.81086 19.5858 6.86308 19.6767C6.9153 19.7676 6.98897 19.8443 7.07767 19.9002C7.16636 19.9561 7.26738 19.9895 7.37192 19.9974C7.47646 20.0053 7.58134 19.9874 7.67742 19.9455C9.38419 19.1939 9.40613 19.1345 9.69548 19.2132C14.6403 20.5742 20 17.4097 20 11.7603C20 7.30129 16.5352 4 12.0177 4ZM16.8319 9.97194L14.4771 13.7C14.3882 13.8402 14.2713 13.9605 14.1337 14.0534C13.9961 14.1463 13.8408 14.2097 13.6775 14.2398C13.5142 14.2699 13.3465 14.2659 13.1849 14.2281C13.0232 14.1904 12.8711 14.1196 12.7381 14.0203L10.8645 12.6181C10.7808 12.5552 10.6789 12.5213 10.5742 12.5213C10.4695 12.5213 10.3676 12.5552 10.2839 12.6181L7.75581 14.5355C7.41839 14.7913 6.97645 14.3871 7.20387 14.03L9.55871 10.3019C9.6476 10.1617 9.76451 10.0414 9.9021 9.94845C10.0397 9.85553 10.195 9.79204 10.3583 9.76197C10.5215 9.73189 10.6893 9.73588 10.8509 9.77368C11.0126 9.81147 11.1647 9.88226 11.2977 9.98161L13.1706 11.3835C13.2544 11.4464 13.3563 11.4803 13.461 11.4803C13.5657 11.4803 13.6675 11.4464 13.7513 11.3835L16.2806 9.46806C16.6174 9.21065 17.0594 9.61452 16.8319 9.97194Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11855_14717",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D672FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#842CC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11855_14717",
    x1: 12,
    y1: 0,
    x2: 8.1495,
    y2: 23.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006BFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.27bab4ea4cf7529fe03a0fbca2ad754a.svg";
export { ForwardRef as ReactComponent };